export const INIT_DELIVERY_AREA = 'deliveryAreas.detail.INIT_DELIVERY_AREA';
export const UPDATE_DELIVERY_AREA = 'deliveryAreas.detail.UPDATE_DELIVERY_AREA';
export const API_READ_DELIVERY_AREA =
  'deliveryAreas.detail.API_READ_DELIVERY_AREA';
export const API_READ_DELIVERY_AREA_REQUEST =
  'deliveryAreas.detail.API_READ_DELIVERY_AREA_REQUEST';
export const API_READ_DELIVERY_AREA_SUCCESS =
  'deliveryAreas.detail.API_READ_DELIVERY_AREA_SUCCESS';
export const API_READ_DELIVERY_AREA_FAILURE =
  'deliveryAreas.detail.API_READ_DELIVERY_AREA_FAILURE';
export const API_SAVE_DELIVERY_AREA =
  'deliveryAreas.detail.API_SAVE_DELIVERY_AREA';
export const API_SAVE_DELIVERY_AREA_REQUEST =
  'deliveryAreas.detail.API_SAVE_DELIVERY_AREA_REQUEST';
export const API_SAVE_DELIVERY_AREA_SUCCESS =
  'deliveryAreas.detail.API_SAVE_DELIVERY_AREA_SUCCESS';
export const API_SAVE_DELIVERY_AREA_FAILURE =
  'deliveryAreas.detail.API_SAVE_DELIVERY_AREA_FAILURE';
export const API_DELETE_DELIVERY_AREA =
  'deliveryAreas.detail.API_DELETE_DELIVERY_AREA';
export const API_DELETE_DELIVERY_AREA_REQUEST =
  'deliveryAreas.detail.API_DELETE_DELIVERY_AREA_REQUEST';
export const API_DELETE_DELIVERY_AREA_SUCCESS =
  'deliveryAreas.detail.API_DELETE_DELIVERY_AREA_SUCCESS';
export const API_DELETE_DELIVERY_AREA_FAILURE =
  'deliveryAreas.detail.API_DELETE_DELIVERY_AREA_FAILURE';

export type INIT_DELIVERY_AREA = typeof INIT_DELIVERY_AREA;
export type UPDATE_DELIVERY_AREA = typeof UPDATE_DELIVERY_AREA;
export type API_READ_DELIVERY_AREA = typeof API_READ_DELIVERY_AREA;
export type API_READ_DELIVERY_AREA_REQUEST =
  typeof API_READ_DELIVERY_AREA_REQUEST;
export type API_READ_DELIVERY_AREA_SUCCESS =
  typeof API_READ_DELIVERY_AREA_SUCCESS;
export type API_READ_DELIVERY_AREA_FAILURE =
  typeof API_READ_DELIVERY_AREA_FAILURE;
export type API_SAVE_DELIVERY_AREA = typeof API_SAVE_DELIVERY_AREA;
export type API_SAVE_DELIVERY_AREA_REQUEST =
  typeof API_SAVE_DELIVERY_AREA_REQUEST;
export type API_SAVE_DELIVERY_AREA_SUCCESS =
  typeof API_SAVE_DELIVERY_AREA_SUCCESS;
export type API_SAVE_DELIVERY_AREA_FAILURE =
  typeof API_SAVE_DELIVERY_AREA_FAILURE;
export type API_DELETE_DELIVERY_AREA = typeof API_DELETE_DELIVERY_AREA;
export type API_DELETE_DELIVERY_AREA_REQUEST =
  typeof API_DELETE_DELIVERY_AREA_REQUEST;
export type API_DELETE_DELIVERY_AREA_SUCCESS =
  typeof API_DELETE_DELIVERY_AREA_SUCCESS;
export type API_DELETE_DELIVERY_AREA_FAILURE =
  typeof API_DELETE_DELIVERY_AREA_FAILURE;
